// Shared domain translation for Service-Center > Insights (list column + search index).
// `t` is a translate function, e.g. component `this.$t` or i18n `i18n.t`.
export function translateInsightDomain(domain, t) {
    if (!domain) return ''

    const mainAreaMap = {
        'publishing': 'lang_PUBLISHING',
        'label': 'lang_LABEL',
        'contracts': 'lang_CONTRACTS',
        'a-z': 'lang_GENERIC_CAPTION_AZ',
        'account': 'lang_ACCOUNT',
        'erp': 'lang_ERP'
    }

    const subAreaMap = {
        'publishing': 'lang_PUBLISHING',
        'label': 'lang_LABEL',
        'works': 'lang_PUBLISHING_CAPTION_WORKS',
        'sheets': 'lang_PUBLISHING_SHEETS',
        'projects': 'lang_PUBLISHING_PROJECTS',
        'income': 'lang_PUBLISHING_INCOME',
        'statements': 'lang_PUBLISHING_STATEMENTS',
        'statistics': 'lang_PUBLISHING_STATISTICS',
        'tracks': 'lang_LABEL_TRACKS',
        'releases': 'lang_LABEL_RELEASES',
        'salesdata': 'lang_LABEL_SALES_DATA',
        'persons': 'lang_AZ_PERSONS',
        'groups': 'lang_AZ_GROUPS',
        'mappings': 'lang_ACCOUNT_MAPPINGS',
        'companies': 'lang_ACCOUNT_COMPANIES',
        'invoices': 'lang_ERP_INVOICES',
        'shipping': 'lang_ERP_SHIPPING',
        'inventories': 'lang_ERP_INVENTORIES'
    }

    const domainLower = domain.toLowerCase()

    if (domainLower.startsWith('a-z-')) {
        const subPart = domainLower.substring(4)
        const mainText = t(mainAreaMap['a-z'])
        const subText = subAreaMap[subPart] ? t(subAreaMap[subPart]) : subPart
        return `${mainText} > ${subText}`
    }

    const parts = domainLower.split('-')

    if (parts.length >= 2 && mainAreaMap[parts[0]]) {
        const mainText = t(mainAreaMap[parts[0]])
        const subPart = parts.slice(1).join('-')
        const subText = subAreaMap[subPart] ? t(subAreaMap[subPart]) : subPart
        return `${mainText} > ${subText}`
    }

    if (subAreaMap[domainLower]) {
        return t(subAreaMap[domainLower])
    }

    return domain
}
